import { save } from "../createpaymentlink/api";

export const transferDetailes = async(url,values) =>{
    try{
       
        let response = await save(url,values);
        if(response.status === 200){
            return response
        }
        else{
            return response.data;
        }
    }
    catch(error){
        return error
    }
   }

   export const SavePendingCommisionDetailes = async(url,values) =>{
    try{
       
        let response = await save(url,values);
        if(response.status === 200){
            return response
        }
        else{
            return response.data;
        }
    }
    catch(error){
        return error
    }
   }